export default {
  PLATFORM_STATE: "platform_state",
  COUNTRY_STATE: "country_state",
  AUTH_STATE: "auth_state",
  ORDERS_STATE: "orders_state",
  ORDER_STATE: "order_state",
  APPOINMENT_STATE: "appointment_state",
  EXPORT_ORDERS_STATE: "export_orders_state",
  PLANS_STATE: "plans_state",
  EVALUATION_ID_PLANS_STATE: "evaluation_id_plans_state",
  REFERRER_PROMOTION_CODE_STATE: "referrer_promotion_code_state",
  SELECTED_PRENATAL_CARD_STATE: "selected_prenatal_card_state",

  EVALUATION: "evaluation_state",
  CURRENT_EVALUATION_ID: "current_evaluation_id_state",
  CURRENT_SECTION_INDEX: "current_section_index_state",
  CURRENT_SECTION: "current_section_state",
  SECTION_VISITS: "section_visits_state",
  EVALUATION_STEPPER_STATE: "evaluation_stepper_state",
  TOTAL_SECTIONS_STATE: "total_sections_state",
  FORM_SECTIONS_STATE: "form_sections_state",
  FORM_QandA_STATE: "form_QandA_state",
  CURRENT_JUMP_TO_TREE_STATE: "current_jump_to_tree_state",
  USER_COMPLETED_EVALUATION_STATE: "user_completed_evaluation_state",
  RELOAD_COMPLETED_EVALUATION_STATE: "reload_completed_evaluation_state",
  GOALS_STATE: "goals_state",
  COMPLETED_EVALUATION_STATE: "completed_evaluation_state",
  UNCOMPLETED_EVALUATIONS_STATE: "uncompleted_evaluations_state",
  UNCOMPLETED_TASKS_STATE: "uncompleted_tasks_state",

  IS_LOADING_STATE: "is_loading_state",
  PATIENT_STATE: "patient_state",
  DOCTOR_STATE: "doctor_state",

  VALID_CHANNELS_STATE: "valid_channel_state",

  PATIENT_DATA_STATE: "PATIENT_DATA_STATE",
  PATIENT_CHECKOUT_INFO_STATE: "patient_checkout_info_state",

  ORDER_CURRENT_TREATMENT_ID_STATE: "order_current_treatment_id_state",

  SELECTED_CATEGORY_STATE: "selected_category",
  PRODUCTS_STATE: "products",
  IS_FETCHING_PRODUCT_STATE: "is_fetching_product_state",
  PRODUCT_SEARCH_VALUE_STATE: "product_search_value_state",
  PRODUCT_SORT_VALUE_STATE: "product_sort_value_state",
  IS_DETAIL_MODAL_OPENED_STATE: "is_detail_modal_opened_state",
  PRICE_MODAL_SELECTED_PRICE_STATE: "price_modal_selected_price_ptate",
  IS_PRICE_MODAL_OPENED_STATE: "is_price_modal_opened_state",
  SELECTED_CONSULT_TYPE_STATE: "selected_consult_type_state",
  IS_ADDING_CART_STATE: "is_adding_cart_state",
  PRICE_MODAL_SELECTED_PRODUCT_STATE: "price_modal_selected_product_state",
  PRICE_MODAL_STEP: "price_modal_step",
  PRODUCT_DETAIL_STATE: "product_detail_state",
  CART_STATE: "cart_state",
  CART_ITEMS_STATE: "cart_items_state",
  CART_ITEM_QUANTITY_STATE: "cart_item_quantity_state",
  ORDER_SUMMARY_STATE: "order_summary_state",
  ORDER_PRODUCT_MAPPING_STATE: "order_product_mapping_state",
  PENDING_PRESCRIPTION_CHANGED_ORDERS_STATE: "pending_prescription_changed_orders_state",
  ORDER_CALCULATION_STATE: "order_calculation_state",
  PAYMENT_INFO_STATE: "payment_info_state",
  IS_CART_UPDATING_STATE: "is-cart_updating_state",
  PROMO_CODE_STATE: "promo_code_state",
  ADDED_PRODUCTS_STATE: "added_products_state",
  IS_SAME_AS_BILLING_ADDRESS_STATE: "is_same_as_billing_address_state",
  NO_MATCHED_STATE: "NO_MATCHED_STATE",
  IS_BUY_NOW_STATE: "is_buy_now_state",
  RETRY_METHOD_STATE: "retry_method_state",
  ACTIVE_PRODUCTS_STATE: "active_products_state",
  IS_FETCHING_ACTIVE_PRODUCTS_STATE: "is_fetching_active_products_state",
  PENDING_EVALS_STATE: "pending_evals_state",
  SELECTED_TREATMENT_STATE: "selected_treatment_state",
  CONDITION_STATE: "condition_state",
  DB_COMPLETED_EVALUATION_STATE: "completed_evaluation_state",
  SECTION_STATE: "section_state",
  SECTION_STATE_HISTORY: "section_state_history",
  CONDITION_SETTING_STATE: "condition_setting_state",
  CURRENT_PRODUCT_GROUP_INDEX_STATE: "current_product_group_index_state",
  CURRENT_PRODUCT_GROUP_STATE: "current_product_group_state",
  IS_LAST_PRODUCT_GROUP_STATE: "is_last_product_group_state",
  PRODUCT_GROUP_STATE: "product_group_state",
  SELECTED_PRODUCT_STATE: "selected_product_state",
  NOTES_STATE: "notes_state",
  CURRENT_VARIATION_LIST_STATE: "current_variation_list_state",
  CURRENT_VARIATION_INDEX_STATE: "current_variation_index_state",
  IS_LAST_VARIATION_STATE: "is_last_variation_state",
  CURRENT_VARIATION_STATE: "current_variation_state",
  CURRENT_PRODUCT_STATE: "current_product_state",
  LIST_PRICE_IDS_BY_VARIATION_STATE: "list_price_ids_by_variation_state",
  SELECTED_VARIATIONS_STATE: "selected_variation_state",
  SELECTED_PRICES_STATE: "selected_prices_state",
  OVERWRITE_PRODUCT_ID_STATE: "overwrite_product_id_state",
  PENDING_PRESCRIPTION_ORDERS_STATE: "pending_prescription_orders_state",
  PENDING_BOOKING_ORDERS_STATE: "pending_booking_orders_state",

  BOOKING_ORDERID_STATE: "booking_orderId_state",
  BOOKING_ORDER_STATE: "booking_order_state",
  IS_CANCEL_BOOKING_MODAL_OPENED_STATE: "is_cancel_booking_modal_opened_state",
  IS_RETRY_MODAL_OPENED_STATE: "is_retry_modal_opened_state",
  BOOKING_ORDER_BY_ID_STATE: "BOOKING_ORDER_BY_ID_STATE",
  USER_DATA_STATE: "USER_DATA_STATE",
  RELOAD_USER_DATA_STATE: "RELOAD_USER_DATA_STATE",
  MODAL_CANCELING_ITEM_STATE: "modal_canceling_item_state",
  SUGGESTION_ITEMS_STATE: "suggestion_items_state",
  IS_PAYMENT_SUCCESS_STATE: "is_payment_success_state",
  IS_PROMOTION_DISABLED_STATE: "is_promotion_disabled_state",
  IS_PROMOTION_APPLIED_STATE: "is_promotion_applied_state",
  IS_WARNING_RENEW_MODAL_OPENED_STATE: "is_warning_renew_modal_opened_state",
  IS_WARNING_IF_PRESCRIBED_MODAL_OPENED_STATE: "is_warning_if_prescribed_modal_opened_state",

  CART_BY_ID_STATE: "CART_BY_ID_STATE",
  ROUTER_CHANGE_STATE: "ROUTER_CHANGE_STATE",

  COMPLETED_EVALUATION_IDS_STATE: "COMPLETED_EVALUATION_IDS_STATE",
  EVALUATION_IDS_BY_ORDERS_STATE: "EVALUATION_IDS_BY_ORDERS_STATE",
  COMPLETED_EVALUATION_ID_STATE: "COMPLETED_EVALUATION_ID_STATE",

  IS_BANNER_PRICE_MODAL_OPENED_STATE: "is_banner_price_modal_opened",
  BANNER_SELECTED_PRODUCT_STATE: "banner_selected_product_state",
  IS_BANNER_MODAL_ADDING_STATE: "is_banner_modal_adding_state",

  CONFIRM_SELECTED_PRODUCT_STATE: "confirm_selected_product_state",
  IS_RENEWAL_PRICE_MODAL_OPENED_STATE: "is_renewal_price_modal_opened_state",
  RENEWAL_SELECTED_PRODUCT_STATE: "renewal_selected_product_state",
  IS_RENEWAL_MODAL_ADDING_STATE: "is_renewal_modal_adding_state",

  IS_EDIT_PRICE_MODAL_OPENED_STATE: "is_edit_price_modal_opened_state",
  EDIT_SELECTED_PRODUCT_STATE: "edit_selected_product_state",
  IS_EDIT_MODAL_ADDING_STATE: "is_edit_modal_adding_state",
  IS_SAME_EVAL_MODAL_OPENED_STATE: "is_same_eval_modal_opened_state",
  IS_CONFLICT_PLATFORM: "is_conflict_platform",
  SAME_EVAL_ID_STATE: "same_eval_id_state",
  IS_CHECKOUT_BUTTON_LOADING_STATE: "is_checkout_button_loading_state",
  ARE_DISABLED_CHECKOUT_BUTTONS_STATE: "are_disabled_checkout_buttons_state",
  GUEST_ITEM_STATE: "guest_item_state",
  IS_CANCEL_MODAL_REMOVING_STATE: "is_cancel_modal_removing_state",
  SAVED_DOB_STATE: "saved_DOB_state",
  EVALS_TOTAL_SECTIONS_STATE: "evals_total_sections_state",
  IS_ENABLE_EDIT_PLAN_STATE: "is_enable_edit_plan_state",

  IS_DELIVERY_EDIT_PRICE_MODAL_OPENED_STATE: "is_delivery_edit_price_modal_opened_state",
  IS_CONSULT_EDIT_PRICE_MODAL_OPENED_STATE: "is_consult_edit_price_modal_opened_state",
  IS_DELIVERY_DETAILS_MODAL_OPENED_STATE: "is_delivery_details_modal_opened_state",
  IS_FAIL_PAYMENT_MODAL_OPENED_STATE: "is_fail_payment_modal_opened_state",
  EDIT_DELIVERY_ORDER_ID: "edit_delivery_order_id",
  EDIT_DELIVERY_CONSULT_DATE: "edit_delivery_consult_date",
  PENDING_DELIVERY_ORDERS_STATE: "pending_delivery_orders_state",

  INSIGHT_PAST_NOTES_FILTER_STATE: "insight_past_notes_filter_state",
  IS_SCROLL_TO_ACTIVE_ELEMENT_STATE: "is_scroll_to_active_element_state",
  UPLOADED_DOCUMENT_STATE: "uploaded_document_state",
  GUEST_CHECKOUT_DATA_STATE: "guest_checkout_data_state",
  SHOW_NORMAL_THANK_YOU_HEADER: "show_normal_thank_you_header",

  PAYMENT_INTENT_STATE: "payment_intent_state",
  IS_FROM_PAYMENT_PAGE_STATE: "is_from_payment_page_state",
  OPS_LOCALE_STATE: "ops_locale_state",
  RENEW_RESULT_MODAL_STATE: "renew_result_modal_state",

  SELECTED_PRESCRIPTION_PRODUCT_STATE: "selected_prescription_product_state",
  EMAIL_PERMISSION_MODAL_STATE: "email_permission_modal_state",
  PRESCRIPTION__CHECKOUT_DATA_STATE: "prescription__checkout_data_state",
  VARIANT_EDIT_STATE: "variant_edit_state"
};
